import React from 'react';
import { ProductSection, ProductSectionProps } from './ProductSection';
import { TrustedHtmlString } from '../../models/globals';

interface SectionWithHtmlContentProps extends ProductSectionProps {
    content: TrustedHtmlString | null;
}

const SectionWithHtmlContent: React.FC<SectionWithHtmlContentProps> = ({ content, ...productSectionProps }) => {
    if (!content) return null;

    return (
        <ProductSection {...productSectionProps}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </ProductSection>
    );
};

export { SectionWithHtmlContent, SectionWithHtmlContentProps };
